import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const CustomInsightsModal = ({ isOpen, onToggle, children, header, className }) => {

    const { modalBodyContainer } = styles;

    return (
        <Modal className={className ? className: 'customerInsightModal'} size="lg" isOpen={isOpen} toggle={() => onToggle()}>
            <ModalHeader toggle={() => onToggle()} className="modalHeader">
                {header}
            </ModalHeader>
            <ModalBody style={modalBodyContainer} className="mediumScrollbar">
                {children}
            </ModalBody>
        </Modal >
    );
}

export default CustomInsightsModal;

const styles = {
    modalBodyContainer: {
        maxHeight: 600,
        overflow: 'auto'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomInsightsModal.js